.wrapper {
  margin-bottom: 60px;
}

.label {
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 16px;
}

.heading {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: clamp(36px, 5vw, 64px);
  color: var(--color-text-primary);
  letter-spacing: -0.03em;
  margin: 0;
  line-height: 1;
}

@media (max-width: 768px) {
  .wrapper {
    margin-bottom: 36px;
  }
}
